export const FLP_REWARDS_SHARE_BEFORE_IGO = 1;
export const FLP_REWARDS_SHARE_AFTER_IGO = 0.6;

export const BTC_LP_WEIGHT = 0.2;
export const ETH_LP_WEIGHT = 0.3;
export const ATOM_LP_WEIGHT = 0.05;
